// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Leads(
  $organization_id: uuid!
  $organization_locations: jsonb
  $name: String!
) {
  leads_create_app(
    organization_id: $organization_id
    organization_locations: $organization_locations
    name: $name
  ) {
    id
  }
}

`